// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import App from './App'
import router from './router'
import { sync } from 'vuex-router-sync'
import store from '@/store/index'
import './theme/default.styl'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCalendarPlus, faCalendar, faCalendarAlt, faThumbsUp, faIdBadge, faClone } from '@fortawesome/free-regular-svg-icons'
import { faCoffee, faUserGraduate, faBookOpen, faBookReader, faLayerGroup,
  faCheck, faQuestion, faAward, faCoins, faTools, faCaretRight, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import { faAppStore, faGooglePlay, faApple } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Vuetify from 'vuetify'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faCalendarAlt, faCalendarPlus, faCalendar, faCoffee, faAppStore, faGooglePlay, faApple, faUserGraduate, faBookOpen, faBookReader, faCaretRight,
  faCheck, faThumbsUp, faQuestion, faAward, faCoins, faLayerGroup, faIdBadge, faTools, faClone, faNewspaper)

// function getCookie (cname) {
//   var name = cname + '='
//   var decodedCookie = decodeURIComponent(document.cookie)
//   var ca = decodedCookie.split(';')
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i]
//     while (c.charAt(0) === ' ') {
//       c = c.substring(1)
//     }
//     if (c.indexOf(name) === 0) {
//       return c.substring(name.length, c.length)
//     }
//   }
//   return ''
// }

Vue.use(Vuetify, {
  theme: {
    primary: '#008ce2',
    secondary: '#b0bec5',
    accent: '#82B1FF',
    info: '#2196F3',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false
// Enable devtools
// Vue.config.devtools = true
// Vue.config.silent = true

Vue.router = router
Vue.use(VueAxios, axios)
Vue.directive('title', {
  inserted: (el, binding) => (document.title = binding.value),
  update: (el, binding) => (document.title = binding.value)
})

const getUrl = () => [62].includes(process.env.GAME_ID) ? `${process.env.API_URL}/ws/playerservice/user/${localStorage.getItem('user_name')}` : `${process.env.API_URL}/ws/playerservice/user/${localStorage.getItem('user_name')}?deck=${process.env.GAME_ID}`

const currLocation = router.history.getCurrentLocation()
let couponStr = ''
const isQuickRegisterPaymentPage = currLocation.indexOf('?coupon') !== -1
if (isQuickRegisterPaymentPage) {
  couponStr = currLocation.substring(currLocation.indexOf('coupon='))
}
console.log('isQuickRegisterPaymentPage: ', couponStr)
// eslint-disable-next-line no-console
console.log(isQuickRegisterPaymentPage ? '/user/payment' + couponStr : '/programs?show=all')

Vue.use(VueAuth, {
  auth: {
    authRedirect: '/programs?show=all',
    request: function (req, token) {
    },
    response: function (res) {
      if (res.status === 401) {
        console.log('401 Caught')
        // clean all localstorage
        localStorage.removeItem('default_auth_token')
        document.cookie = 'user_name=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
        document.cookie = 'user_email=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
        document.cookie = 'auth_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=cogneti.com'
      }
      if (res.status === 400 || res.status === 500) {
        store.commit('flashError', 'Unable to process your request.')
      }
      // Get Token from response body
      return res.data.access_token
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  fetchData: {
    url: getUrl(),
    method: 'GET',
    enabled: true,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('default_auth_token')
    }
  },
  loginData: {
    url: process.env.API_URL + '/sec/oauth/token',
    method: 'POST',
    redirect: isQuickRegisterPaymentPage ? '/user/payment?' + couponStr : '/programs?show=all',
    fetchUser: false
  },
  refreshData: { enabled: false },
  rolesVar: 'roleId'
})

sync(store, router)

// Vue.prototype.APP_ICON = require('@/assets/logos/' + process.env.APP_ICON)

// if (process.env.NODE_ENV === 'production') {
//   document.cookie = 'rememberMe=false;'
//   const authToken = getCookie('user_email')
//   if (!authToken) {
//     localStorage.removeItem('default_auth_token')
//   }
// }
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js